module.exports = require("./yo");